export const getPatientsItems = (state) => state.patients.patients
export const getPatientsPagination = (state) => state.patients.pagination
export const getIsLoadingPatients = (state) => state.patients.isLoading

export const getPatientReceprionsItem = (state) => state.patients.receptions
export const getReceptionsPagination = (state) =>
  state.patients.paginationReception

export const getLoadResultInfo = (state) => state.patients.loadResult
